// extracted by mini-css-extract-plugin
module.exports = {"timeContainer":"TimeBox_timeContainer__3LS-4","timeText":"TimeBox_timeText__2hdco","timeNumber":"TimeBox_timeNumber__2Hu0_","timeDivider":"TimeBox_timeDivider__1ERXa"};